import {
  $HttpNotFound,
  $HttpOk,
  $HttpUnauthorized,
  $Resource,
} from '@flowio/api-sdk';

// FIXME: Remove this file once @flowio/api-sdk and @flowio/api-types are
// upgraded — FeeInvoicesResource exists in api-sdk >= 0.0.114, but every such
// version has already dropped resources console still uses (Experiences,
// Subcatalogs, Returns, PriceBooks, OrderBuilders, Optin models, ...), so the
// upgrade first requires migrating those call sites off the removed resources.

export type FeeInvoiceType = 'mor_invoice' | 'label_invoice' | 'mor_credit_memo' | 'label_credit_memo';

export interface FeeInvoice {
  readonly id: string;
  readonly number: string;
  readonly invoice_type: FeeInvoiceType;
  readonly buyer: io.flow.v0.models.MerchantOfRecordEntity;
  readonly seller: io.flow.v0.models.MerchantOfRecordEntity;
  readonly date: string;
  readonly order_number: string;
  readonly documents: io.flow.v0.models.ConsumerInvoiceDocument[];
}

export interface FeeInvoicesGetParameters {
  organization: string;
  order_number?: string;
  limit?: number;
  offset?: number;
  sort?: string;
}

export type FeeInvoicesGetResponse =
  $HttpOk<FeeInvoice[]> | $HttpUnauthorized<undefined> | $HttpNotFound<undefined>;

export class FeeInvoicesResource extends $Resource {
  get(params: FeeInvoicesGetParameters): Promise<FeeInvoicesGetResponse> {
    return this.client.request({
      endpoint: `/${encodeURIComponent(params.organization)}/ledger/fee/invoices`,
      method: 'GET',
      query: {
        limit: params.limit,
        offset: params.offset,
        order_number: params.order_number,
        sort: params.sort,
      },
    }) as Promise<FeeInvoicesGetResponse>;
  }
}
